(() => {
  // app/scripts/main-page.js
  function updateReviewText() {
    document.querySelectorAll(".total-reviews").forEach(function(span) {
      let match = span.textContent.match(/\d+/);
      if (match) {
        span.textContent = `(${match[0]})`;
      }
    });
  }
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === "childList") {
        updateReviewText();
        setTimeout(function() {
          const filterContainer = document.querySelector(".snize-search-results");
          if (filterContainer) {
            ["click", "input", "change"].forEach((e) => {
              observer.observe(document.querySelector(".shopify-section-main-page"), { childList: true, subtree: true });
            });
          }
        }, 500);
        observer.disconnect();
      }
    });
  });
  function isIOS() {
    return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  }
  if (!isIOS()) {
    observer.observe(document.querySelector(".shopify-section-main-page"), { childList: true, subtree: true });
  }
  setTimeout(function() {
    const filterContainer = document.querySelector(".snize-search-results");
    if (filterContainer) {
      ["click", "input", "change"].forEach((e) => {
        observer.observe(document.querySelector(".shopify-section-main-page"), { childList: true, subtree: true });
      });
    }
  }, 3e3);
})();
